<section class="flex flex-col space-y-2">
  @for (source of sources; track source) {
    <aux-investigator-forecast-source-select-item
      [control]="control"
      [label]="source.label"
      [value]="source.value"
      [icon]="source.icon"
      [avgPatientCost]="source.avgPatientCost"
      [forecastTotal]="source.forecastTotal"
      [spendToDate]="source.spendToDate"
      [remaining]="source.remaining"
    />
  }
</section>
